/* eslint-disable no-useless-catch */
import { serialize } from 'utils/crud';

import { FindOneOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-notify';

export const EntityNotifyApi = {
  filter: async (option: FindOneOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createNotificationZalo: async (body: any) => {
    try {
      const url = `${pathname}/zalo`;
      const response = await entityService.post(url, body);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateNotificationZalo: async (id: string, body: any) => {
    try {
      const url = `${pathname}/zalo/${id}`;
      const response = await entityService.patch(url, body);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  find: async (option: FindOneOptions) => {
    let url = `${pathname}/find-with-entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string | undefined) => {
    const url = `${pathname}/${id}`;
    // const query = serialize(option);
    // url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneEntityNotificationZalo: async (id: string | undefined) => {
    const url = `${pathname}/zalo/${id}`;
    // const query = serialize(option);
    // url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findNotificationZalo: async (option: any) => {
    const { entityIDs, ...param } = option;

    let url = `${pathname}/zalo/find-with-entity`;
    const query = serialize(param);
    url += query;

    try {
      const response = await entityService.post(url, {
        entityIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  findEntityForSetting: async (option: any) => {
    const { excludedEntityIDs, ...param } = option;

    let url = `${pathname}/zalo/find-entity-for-setting`;
    const query = serialize(param);
    url += query;

    try {
      const response = await entityService.post(url, {
        excludedEntityIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
